import { put, call, takeLatest } from 'redux-saga/effects';
import * as actions from '../redux/actions/configuration';
import { config } from '../services/api/configuration';
import { DEFAULT_LOCALE, BAD_REQUEST_ERROR_CODE } from '../constants';

export function* callConfigurationApi(param) {
  try {
    // Skip API call in development mode to prevent timeout issues
    if (process.env.REACT_APP_DEVELOPMENT_MODE === 'true') {
      console.log('Development mode - using fallback configuration');
      const fallbackConfig = {
        locale: DEFAULT_LOCALE,
        developmentMode: true,
        timestamp: new Date().toISOString(),
        landingPage: {
          content: {
            pageInfo: {
              pageTitle: 'Development Landing Page'
            },
            components: [
              {
                id: 'c-hero',
                object: [{
                  pageDescription: {
                    object: {
                      heading: 'Welcome to Development Mode',
                      description: 'This is a fallback landing page for development environment. The application is running in development mode with mock configuration.',
                      'info-pod': {
                        title: 'Development Info',
                        text: 'Application running in development mode',
                        'icon-image': null
                      }
                    }
                  },
                  image: {
                    Desktop: 'placeholder.jpg',
                    Mobile: 'placeholder.jpg',
                    altText: 'Development placeholder image'
                  }
                }]
              }
            ]
          }
        }
      };
      yield put(actions.receiveConfiguration({ data: fallbackConfig }));
      return;
    }

    const result = yield call(config, (param && param.payload) || DEFAULT_LOCALE);
    
    // Check if we got fallback data due to API issues
    if (result.data && result.data.fallback) {
      console.warn('Using fallback configuration due to API issues');
      // Use local fallback configuration
      const fallbackConfig = {
        locale: DEFAULT_LOCALE,
        fallbackMode: true,
        timestamp: new Date().toISOString(),
        landingPage: {
          content: {
            pageInfo: {
              pageTitle: 'Service Unavailable'
            },
            components: [
              {
                id: 'c-hero',
                object: [{
                  pageDescription: {
                    object: {
                      heading: 'Service Temporarily Unavailable',
                      description: 'Unable to connect to configuration service. Please try again later or contact support if the issue persists.',
                      'info-pod': {
                        title: 'Service Status',
                        text: 'Configuration service is currently unavailable',
                        'icon-image': null
                      }
                    }
                  },
                  image: {
                    Desktop: 'error-placeholder.jpg',
                    Mobile: 'error-placeholder.jpg',
                    altText: 'Service unavailable placeholder'
                  }
                }]
              }
            ]
          }
        }
      };
      yield put(actions.receiveConfiguration({ data: fallbackConfig }));
      return;
    }

    yield put(actions.receiveConfiguration(result));
  } catch (error) {
    console.warn('Configuration API error:', error.message);
    
    // Try with default locale as fallback
    try {
      if (error.response && error.response.status === BAD_REQUEST_ERROR_CODE) {
        const result = yield call(config, DEFAULT_LOCALE);
        if (result.data && !result.data.fallback) {
          yield put(actions.receiveConfiguration(result));
          return;
        }
      }
    } catch (fallbackError) {
      console.warn('Default locale fallback also failed:', fallbackError.message);
    }

    // Use local fallback configuration if all API calls fail
    const fallbackConfig = {
      locale: DEFAULT_LOCALE,
      fallbackMode: true,
      error: error.message,
      timestamp: new Date().toISOString()
    };
    
    yield put(actions.receiveConfiguration({ data: fallbackConfig }));
  }
}

export function* getConfiguration() {
  yield takeLatest(actions.GET_CONFIGURATION, callConfigurationApi);
}

